import * as React from 'react';
import { cn } from '../lib/cn';

// The prototype's filter control: a green outlined pill ("Group by: customer ▾", "SLA breached only"); filled when on.
export const FilterButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement> & { on?: boolean }>(
  ({ on = false, className, ...p }, ref) => (
    <button ref={ref} type="button" aria-pressed={on}
      className={cn('inline-flex h-9 items-center gap-1.5 rounded-full border px-4 text-sm font-semibold transition-colors',
        on ? 'border-tick-ink bg-tick-ink text-white' : 'border-tick-ink/60 bg-surface text-tick-ink hover:bg-mint-2', className)} {...p} />
  ));
FilterButton.displayName = 'FilterButton';
